<template>
  <div class="report-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">

          <b-card>
            <div slot="header">
              {{$t('client.config')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <b-form-group v-for="(option, i) in report.list" :key="i+0" v-bind:label="option.name" :label-cols="4" :horizontal="true">
                  <b-row>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.display')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="report.list[i].show" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import cSwitch from '../../../components/Switch'
  import Customization from './Customization'

  export default {
    name: 'ReportForm',
    props: {
      value: {
        type: Object
      }
    },
    components: {
      Customization,
      cSwitch
    },
    data: function () {
      return {
        position_fields: [
          'name_seo',
        ],
        report: {
          basic_info: [],
          fields: [],
          config: {
            show_point: true,
            show_full_address: false
          },
          list: [
            {
              'name': 'Online/Offline Payment Method Display',
              'type': 'on-offline_payment_method_display',
              'show': false
            },
            {
              'name': 'Brazil Payment Method Feature',
              'type': 'bra_payment_method_feature',
              'show': false,
              'data': {
                'payment_methods': {
                  'online': [
                    'Credit card'
                  ],
                  'offline': [
                    'Cash on Delivery',
                    'Swipe on Delivery'
                  ]
                }
              }
            },
            {
              'name': 'Export Order Summary Report (CSV)',
              'type': 'export_order_summary_report_csv',
              'show': false
            },
            {
              'name': 'Export Hourly Sales Report (CSV)',
              'type': 'export_hourly_sales_report_csv',
              'show': false
            },
            {
              'name': 'GCash',
              'type': 'gcash',
              'show': false
            },
            {
              'name': 'PayMaya',
              'type': 'paymaya',
              'show': false
            }
          ]
        }
      }
    },
    methods: {
      updateData () {
        // Update Base Info
        if (this.value != null && this.value.basic_info != null) {
          let basicInfo = {}
          for (let i in this.value.basic_info) {
            basicInfo[this.value.basic_info[i].type] = {
              show: this.value.basic_info[i].show,
              disable: this.value.basic_info[i].disable
            }
          }

          for (let i in this.report.basic_info) {
            if (basicInfo[this.report.basic_info[i].type] != null) {
              this.report.basic_info[i].show = basicInfo[this.report.basic_info[i].type].show
              this.report.basic_info[i].disable = basicInfo[this.report.basic_info[i].type].disable
            }
          }
        }

        // Update List Info
        if (this.value != null && this.value.list != null) {
          let basicInfo = {}
          for (let i in this.value.list) {
            basicInfo[this.value.list[i].type] = {
              show: this.value.list[i].show,
              disable: this.value.list[i].disable
            }
          }

          for (let i in this.report.list) {
            if (basicInfo[this.report.list[i].type] != null) {
              this.report.list[i].show = basicInfo[this.report.list[i].type].show
              this.report.list[i].disable = basicInfo[this.report.list[i].type].disable
            }
          }
        }

        // Update Config
        if (this.value != null && this.value.config != null) {
          for (let i in this.report.config) {
            if (this.value.config[i] != null) {
              this.report.config[i] = this.value.config[i]
            }
          }
        }

        // Update customization field
        if (this.value != null && this.value.fields != null) {
          this.report.fields = this.value.fields
        }
      }
    },
    created: function () {
    },
    mounted: function () {
      this.updateData()
    },
    watch: {
      report: {
        handler: function (newValue) {
          this.$emit('input', this.report)
          this.$emit('change', this.report)
        },
        deep: true
      },
      value: {
        handler: function (newValue) {
          this.updateData()
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/admin/client/ReportForm.vue